var iatShop = typeof Shopify !== 'undefined' ? Shopify.shop : document.domain;

var iatShopDomain = document.domain;

var iatBasePath = 'https://' + iatShopDomain + '/a/iat/';

var iatHead = document.getElementsByTagName('head')[0];

var iatAppSettings = "";

var iatCountryCode = "";

var iatloginForm = "";

var iatRegistrationForm = "";

var iatContactForm = "";

var iatCartForm = "";

// LOAD PRODUCT JSON
var igtTermsJsonTag =  document.querySelector("[td-terms-json]");
if (typeof(igtTermsJsonTag) != 'undefined' && igtTermsJsonTag != null) {
  igtJson = JSON.parse(igtTermsJsonTag.innerHTML);
}
// Add JQuery

if (typeof jQuery == 'undefined') {

    var iatScript = document.createElement('script');

    iatScript.src = iatBasePath + 'js/lib/jquery-3.4.1.min.js';

    iatScript.type = 'text/javascript';

    iatScript.onreadystatechange = iatHandler;

    iatScript.onload = iatHandler;

    // Fire the loading

    iatHead.appendChild(iatScript);

} else {

    iatHandler();

}

function iatHandler() {

    $iatjobject = window.jQuery;

    // Modal Popup

    if (typeof tingle == 'undefined') {

        var head = document.getElementsByTagName('head')[0];

        var script = document.createElement('script');

        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/tingle/0.15.3/tingle.min.js';

        script.type = 'text/javascript';

        script.onreadystatechange = iatModal;

        script.onload = iatModal;

        // Fire the loading

        head.appendChild(script);

    } else {

        iatModal();

    }

    var iatTimeStamp = new Date().getUTCMilliseconds() + new Date().getTime();

    iatloginForm = $iatjobject('form[action="/account/login"] button, form[action="/account/login"] input[type=submit], .igtLogin');

    iatRegistrationForm = $iatjobject('form[action="/account"] button, form[action="/account"] input[type=submit], .igtRegistration');

    iatContactForm = $iatjobject('form[action="/contact#ContactForm"] button, form[action="/contact#ContactForm"] input[type=submit], .igtContact');

    iatCartForm = $iatjobject('form[action="/cart"] button, .igtCart');

    var iatCollection = igtJson;

  // Assign App settings gobally
  iatAppSettings = iatCollection;

  if (iatCollection) {

    console.log(iatCollection.enable_specific_countries);

      if (parseInt(iatCollection.status) == 1) {

          if (parseInt(iatCollection.enable_specific_countries)) {

              iatCountryCode = iatCheckCountryHandler($iatjobject);

              iatCountryCode.then(function (data) {

                  if ($iatjobject.inArray(data.YourFuckingCountryCode, JSON.parse(iatCollection.specific_countries)) == -1) {

                      return false;

                  } else {

                      iatActions($iatjobject, iatCollection, iatTimeStamp)

                  }

              });

          } else {

              iatActions($iatjobject, iatCollection, iatTimeStamp)

          }

      }
  }

}

function iatAddCSS() {

    var iatCss = '.agree-to-terms-wrapper p.text-wrapper {float: none;clear: both;margin: 10px 0;}.agree-to-terms-wrapper label.label-wrapper {display: inline;float: none;margin-left: 10px;}#td-terms {float: none;vertical-align: middle;margin-right: 5px;}.agree-to-terms-wrapper { width: 100%;display: block;} .agree-to-terms-wrapper .text-wrapper input {vertical-align: middle;margin-right: 5px;}span.td-warning { display: block; margin-bottom: 10px; font-size: 14px; color: red;} span.td-warning:before { content: "*";margin: 2px;}.agree-to-terms-wrapper a.td-link {color: #0000ff;text-decoration: underline;}.agree-to-terms-wrapper [type="checkbox"] {appearance: checkbox;-moz-appearance: checkbox;-o-appearance: checkbox;-webkit-appearance: checkbox;}.agree-to-terms-wrapper p {display: inline-block;}.agree-to-terms-wrapper p a {text-decoration: underline;}';

    var iatStyle = document.createElement('style');

    iatHead.appendChild(iatStyle);

    iatStyle.type = 'text/css';

    if (iatStyle.styleSheet) {

        // This is required for IE8 and below.

        iatStyle.styleSheet.cssText = iatCss;

    } else {

        iatStyle.appendChild(document.createTextNode(iatCss));

    }

}

function iatLoadApp($iatjobject, iatCollection, iatTimeStamp, iatPlaceElemId) {

    iatGetAppHTML = iatAppHTML(iatCollection, iatTimeStamp);

    // For Login Page

    if ((iatloginForm.length >= 1 && iatCollection.login_page)) {

        // Place the HTML data

        iatSetupCheckbox(iatloginForm, iatGetAppHTML);

    }

    // For Registration Page

    if ((iatRegistrationForm.length >= 1 && iatCollection.register_page)) {

        iatSetupCheckbox(iatRegistrationForm, iatGetAppHTML);

    }

    // For Contact Page

    if ((iatContactForm.length >= 1 && iatCollection.contact_page)) {

      iatSetupCheckbox(iatContactForm, iatGetAppHTML);

  }



    var iatPlaceElem = "";

    if (iatPlaceElemId == 1) {

        iatPlaceElem = $iatjobject($iatjobject('[name=checkout]')[$iatjobject('[name=checkout]').length - 1]);

        var checkoutParent = iatPlaceElem.parent();

        $iatjobject(checkoutParent.children()).each(function () {

            if ($iatjobject(this).attr('name') && $iatjobject(this).attr('name').indexOf('update') !== -1) {

                iatPlaceElem = $iatjobject(this);

            }

        });            

    } else if (iatPlaceElemId == 2) {

        iatPlaceElem = jQuery('.tech-dignity-terms-box');

    }

    if (iatCollection.enable_specific_product == 1) {

        $iatjobject.getJSON('/cart.js', function (cart) {

            var tdLoadCart = 0;

            if (cart != '') {

                var tdCartItems = cart.items;

                $iatjobject.each(tdCartItems, function (key, tdItem) {

                    var tdProductData = igtGetProduct(tdItem.handle);

                    var tdProductFlag = igtProductCheck(tdProductData, iatCollection);

                    //console.log(tdProductFlag);

                    if (tdProductFlag == true) {

                        tdLoadCart = 1;

                    }

                });

            }

            if (tdLoadCart == 1) {

                // Place the HTML data

                iatSetupCheckbox(iatPlaceElem, iatGetAppHTML);

            }

        });

    } else {

        // Place the HTML data

        iatSetupCheckbox(iatPlaceElem, iatGetAppHTML);

    }

}

function iatloadLanguage(iatCollection, iatNeededParam) {

    var iatLanguage = $iatjobject('html').attr('lang');

    if (!iatLanguage || iatLanguage == '') {

        iatLanguage = $iatjobject('#iatLang').attr('lang');

    }

    var iatLanguageText = {};

    var iatEditor = parseInt(iatCollection.editor);

    if (!iatCollection.shoplanguage || iatCollection.shoplanguage.length === 0) {

        if (iatEditor == 1) {

            iatLanguageText['checkbox_text'] = iatCollection.checkbox_text;

        } else {

            iatLanguageText['checkbox_text'] = iatCollection.editor_text;

        }

        iatLanguageText['click_text'] = iatCollection.click_text ? iatCollection.click_text : 'Click here.';

        iatLanguageText['checkbox_link'] = iatCollection.checkbox_link;

        iatLanguageText['warning_text'] = iatCollection.warning_text;

        iatLanguageText['login_error_msg'] = iatCollection.login_error_msg;

        iatLanguageText['register_error_msg'] = iatCollection.register_error_msg;

        iatLanguageText['login_editor_text'] = iatCollection.login_editor_text;
        iatLanguageText['register_editor_text'] = iatCollection.register_editor_text;
        iatLanguageText['register_editor_text'] = iatCollection.register_editor_text;
        iatLanguageText['contact_editor_text'] = iatCollection.contact_editor_text;
        iatLanguageText['contact_error_msg'] = iatCollection.contact_error_msg;          

        if(iatCollection.enable_dynamic_attribute == 1){
          iatLanguageText['terms_checked_label'] = iatCollection.terms_checked_label;
          iatLanguageText['terms_time_label'] = iatCollection.terms_time_label;
        }

    } else {

        var iatshopLanguage = iatCollection.shoplanguage;

        $iatjobject.each(iatshopLanguage, function (index, val) {

            if (index == iatLanguage) {

                if (iatEditor == 1) {

                    iatLanguageText['checkbox_text'] = val.checkbox_text;

                } else {

                    iatLanguageText['checkbox_text'] = val.editor_text;

                }

                iatLanguageText['click_text'] = val.click_text ? val.click_text : 'Click here.';

                iatLanguageText['checkbox_link'] = val.checkbox_link;

                iatLanguageText['warning_text'] = val.warning_text;

                iatLanguageText['login_error_msg'] = val.login_error_msg;

                iatLanguageText['register_error_msg'] = val.register_error_msg;

                iatLanguageText['login_editor_text'] = val.login_editor_text;
                iatLanguageText['register_editor_text'] = val.register_editor_text;

                iatLanguageText['contact_editor_text'] = val.contact_editor_text;
                iatLanguageText['contact_error_msg'] = val.contact_error_msg;

                if(iatCollection.enable_dynamic_attribute == 1){
                  iatLanguageText['terms_checked_label'] = val.terms_checked_label;
                  iatLanguageText['terms_time_label'] = val.terms_time_label;
                }

                return false;

            } else {

                if (iatEditor == 1) {

                    iatLanguageText['checkbox_text'] = iatCollection.checkbox_text;

                } else {

                    iatLanguageText['checkbox_text'] = iatCollection.editor_text;

                }

                iatLanguageText['click_text'] = iatCollection.click_text ? iatCollection.click_text : 'Click here.';

                iatLanguageText['checkbox_link'] = iatCollection.checkbox_link;

                iatLanguageText['warning_text'] = iatCollection.warning_text;

                iatLanguageText['login_error_msg'] = iatCollection.login_error_msg;

                iatLanguageText['register_error_msg'] = iatCollection.register_error_msg;

                iatLanguageText['login_editor_text'] = iatCollection.login_editor_text;
                iatLanguageText['register_editor_text'] = iatCollection.register_editor_text;

                iatLanguageText['contact_editor_text'] = iatCollection.contact_editor_text;
                iatLanguageText['contact_error_msg'] = iatCollection.contact_error_msg;

                if(iatCollection.enable_dynamic_attribute == 1){
                  iatLanguageText['terms_checked_label'] = iatCollection.terms_checked_label;
                  iatLanguageText['terms_time_label'] = iatCollection.terms_time_label;
                }

            }

        });

    }

    if (iatNeededParam == "current_language") {

        return iatLanguageText;

    }

    return iatLanguageText[iatNeededParam];

}

function iatAppHTML(iatCollection, iatTimeStamp) {

    var iatLayout = parseInt(iatCollection.layout);

    var iatStyle = parseInt(iatCollection.td_style);

    var iatEditor = parseInt(iatCollection.editor);

    var iatDefaultChecked = parseInt(iatCollection.default_checked);

    var iatLink = iatloadLanguage(iatCollection, "checkbox_link");

    var iatSize = 13;

    var iatTarget = '';

    var iatClickText = iatloadLanguage(iatCollection, "click_text");

    var iatWarningTextHtml = '';

    var iatCheckedText = '';

    var iatCheckboxText = iatloadLanguage(iatCollection, "checkbox_text");

    var iatAttrText = "I-Agree-To-Terms";
    var iatTimeAttrText = "Accepted-Terms-At";

    var iatFrmTag = "cart";
    
    if(iatCollection.enable_dynamic_attribute == 1){
      iatAttrText = iatloadLanguage(iatCollection,"terms_checked_label");
      iatTimeAttrText = iatloadLanguage(iatCollection,"terms_time_label");
    }    

    var iatAttrName = 'attributes['+iatAttrText+']';
    var iatTimeAttrName = 'attributes['+iatTimeAttrText+']';

    //console.log(iatCollection);

    if (iatDefaultChecked) {

        iatCheckedText = 'checked';

    }

    if (iatCollection.checkbox_link == '') {

        iatLink = 'javascript:void(0);';

    }

    if (iatCollection.size) {

        iatSize = iatCollection.size;

    }

    if (iatCollection.target == 1) {

        iatTarget = '_blank';

    } else {

        iatTarget = '_self';

    }
    //For Login Page
    if(iatloginForm.length >= 1 && iatCollection.login_page){
      iatCheckboxText = iatloadLanguage(iatCollection,"login_editor_text");
      var iatloginFormId = iatloginForm.closest("form").attr('id');
      if(iatloginFormId != "" && iatloginFormId != null){
        iatFrmTag = iatloginFormId;  
      }else{
        iatFrmTag = "customer_login";  
      }

      //Hook for add login form id
      if($iatjobject.isFunction(window.iatModifyLoginFormId)) {
        if(iatModifyLoginFormId(iatFormId)) {
            iatFrmTag = iatModifyLoginFormId(iatFormId);
        }
      }
      
    }

    //For Registration Page
    if (iatRegistrationForm.length >= 1 && iatCollection.register_page) {
      iatAttrName = "customer[note]["+iatAttrText+"]";
      iatTimeAttrName = "customer[note]["+iatTimeAttrText+"]";
      iatCheckboxText = iatloadLanguage(iatCollection,"register_editor_text");
      //iatFrmTag = "";
      var iatRegistrationFormId = iatRegistrationForm.closest("form").attr('id');
      if(iatRegistrationFormId != "" && iatRegistrationFormId != null){
        iatFrmTag = iatRegistrationFormId;  
      }else{
        iatFrmTag = "create_customer";  
      }

      //Hook for add Registration form id
      if($iatjobject.isFunction(window.iatModifyRegFormId)) {
        if(iatModifyRegFormId(iatFrmTag)) {
            iatFrmTag = iatModifyRegFormId(iatFrmTag);
        }
      }
      
    }
  
    //For Contact Page
    if(iatContactForm.length >= 1 && iatCollection.contact_page){
      iatAttrName = "contact["+iatAttrText+"]";
      iatTimeAttrName = "contact["+iatTimeAttrText+"]";
      iatCheckboxText = iatloadLanguage(iatCollection,"contact_editor_text");
      //console.log(iatContactForm.closest("form").attr('id'));
      var iatContactFormId = iatContactForm.closest("form").attr('id');
      if(iatContactFormId != "" && iatContactFormId != null){
        iatFrmTag = iatContactFormId;  
      }else{
        iatFrmTag = "ContactForm";  
      }

      //Hook for add Contact form id
      if($iatjobject.isFunction(window.iatModifyContactFormId)) {
        if(iatModifyContactFormId(iatFrmTag)) {
            iatFrmTag = iatModifyContactFormId(iatFrmTag);
        }
      }
      
    }

    //For Cart Page
    if(iatCartForm.length >= 1 && iatContactForm.length == 0 && iatRegistrationForm.length == 0 && iatloginForm.length == 0){
    
        var iatPageCheck = $iatjobject(location).attr("pathname");
        var iatCartFormId = iatCartForm.closest("form").attr('id');
        
        if(iatCartFormId != "" && iatCartFormId != null && !iatPageCheck.includes("cart")){
            iatFrmTag = iatCartFormId;  
        }else{
            iatFrmTag = "cart";
        }
      
      //Hook for add Contact form id
      if($iatjobject.isFunction(window.iatModifyCartFormId)) {
        if(iatModifyCartFormId(iatFrmTag)) {
            iatFrmTag = iatModifyCartFormId(iatFrmTag);
        }
      }
      
    }
  

    if (iatStyle == 2) {

        if (iatDefaultChecked) {

            var iatStyleWarning = 'style="display:none";';

        } else {

            var iatStyleWarning = 'style="display:block";';

        }

        iatWarningTextHtml = iatGetWarningMessageHTML(iatStyleWarning, iatCollection);

    }

    if (iatEditor == 1) {

        if (iatLayout == 1) {

            var iatTcHtml = '<div class="agree-to-terms-wrapper"><p class="text-wrapper"><label class="label-wrapper"><input type="hidden" name="' + iatTimeAttrName + '" value="' + new Date() + '" form="'+iatFrmTag+'"><input name="' + iatAttrName + '" value="Yes" style="height:' + iatSize + 'px; width:' + iatSize + 'px;" type="checkbox" id="td-terms-' + iatTimeStamp + '" ' + iatCheckedText + ' form="'+iatFrmTag+'" /><a class="td-non-link" target="' + iatTarget + '" href="' + iatLink + '">' + iatCheckboxText + '</a></label></p>' + iatWarningTextHtml + '</div>';

        } else if (iatLayout == 2) {

            var iatTcHtml = '<div class="agree-to-terms-wrapper"><p class="text-wrapper"><label class="label-wrapper"><input type="hidden" name="' + iatTimeAttrName + '" value="' + new Date() + '" form="'+iatFrmTag+'"><input name="' + iatAttrName + '" value="Yes" style="height:' + iatSize + 'px; width:' + iatSize + 'px;" type="checkbox" id="td-terms-' + iatTimeStamp + '" ' + iatCheckedText + ' form="'+iatFrmTag+'" /><a class="td-link" target="' + iatTarget + '" href="' + iatLink + '">' + iatCheckboxText + '</a></label></p>' + iatWarningTextHtml + '</div>';

        } else if (iatLayout == 3) {

            var iatTcHtml = '<div class="agree-to-terms-wrapper"><p class="text-wrapper"><input type="hidden" name="' + iatTimeAttrName + '" value="' + new Date() + '" form="'+iatFrmTag+'" ><input name="' + iatAttrName + '" value="Yes" style="height:' + iatSize + 'px; width:' + iatSize + 'px;" type="checkbox" id="td-terms-' + iatTimeStamp + '" ' + iatCheckedText + ' form="'+iatFrmTag+'" /><label for="td-terms-' + iatTimeStamp + '" class="label-wrapper">' + iatCheckboxText + '</label><a class="td-link" target="' + iatTarget + '" href="' + iatLink + '">' + iatClickText + '</a></p>' + iatWarningTextHtml + '</div>';

        }

    } else {

        var iatTcHtml = '<div class="agree-to-terms-wrapper"><p class="text-wrapper"><input type="hidden" name="' + iatTimeAttrName + '" value="' + new Date() + '" form="cart" ><input name="' + iatAttrName + '" value="Yes" style="height:' + iatSize + 'px; width:' + iatSize + 'px;" type="checkbox" id="td-terms-' + iatTimeStamp + '" ' + iatCheckedText + ' form="'+iatFrmTag+'" />' + iatCheckboxText + '</p>' + iatWarningTextHtml + '</div>';

    }

    iatTcHtml += '<style type="text/css" style="display:none">' + iatCollection.custom_style + '</style>';

    return iatTcHtml;

}

function iatModal() {

    $iatjobject = window.jQuery;

    $iatjobject('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tingle/0.15.3/tingle.min.css" type="text/css" />');

    var TDShopifyBuyButtonId = $iatjobject('.shopify-payment-button').length;

    if (TDShopifyBuyButtonId) {

        var iatTimestamp = new Date().getUTCMilliseconds() + new Date().getTime();
        var iatcollection = igtJson;
        if (iatcollection) {

            if (parseInt(iatcollection.status) && parseInt(iatcollection.required) && parseInt(iatcollection.buynow) == 1) {

                if (parseInt(iatcollection.enable_specific_countries)) {

                    iatCountryCode = iatCheckCountryHandler($iatjobject);

                    iatCountryCode.then(function (data) {
                        if ($iatjobject.inArray(data.YourFuckingCountryCode, JSON.parse(iatcollection.specific_countries)) == -1) {
                            return false;
                        } else {
                            iatModalWrapper(iatcollection);
                        }
                    });
                } else {
                    iatModalWrapper(iatcollection);
                }
            }
        }
    }

}



function iatModalWrapper(iatCollection) {

    //console.log(iatCollection);

    if (iatCollection.enable_specific_product == 1) { 

        var handle = window.location.href.split("/").pop();       

        $iatjobject.ajax({

            dataType: "json",

            cache: false,

            async: false,

            url: "/products/" + handle + ".json",

            success: function(data) {

                var tdProductData = data.product;

                //console.log(tdProductData);

                var tdProductFlag = igtProductCheck(tdProductData, iatCollection);

               // console.log(tdProductFlag);

                if (tdProductFlag == true) {                        

                    $iatjobject('.shopify-payment-button').wrap("<a class='tdbuynow' onclick='_007td86(this)'></div>");

                    $iatjobject('.shopify-payment-button').css({ 'pointer-events': 'none' });

                }

            }

        });            

    } else {

        $iatjobject('.shopify-payment-button').wrap("<a class='tdbuynow' onclick='_007td86(this)'></div>");

        $iatjobject('.shopify-payment-button').css({ 'pointer-events': 'none' });

    }        

}



function _007td86(data) {

    $iatjobject = window.jQuery;

    var $iatelement = $iatjobject(data);

    var iatTimeStamp = new Date().getUTCMilliseconds() + new Date().getTime();

    var iatCollection = iatAppSettings;

    var iatGetAppHTML = iatAppHTML(iatCollection, iatTimeStamp);

    var tingleModal = new tingle.modal({

        footer: true,

        stickyFooter: false,

        closeMethods: ['overlay', 'button', 'escape'],

        closeLabel: "Close",

        cssClass: ['td-buy-now-modal'],

        onOpen: function () { },

        onClose: function () { },

        beforeClose: function () {

            return true; // close the modal

        }

    });

    var iatPopupWarning = iatloadLanguage(iatAppSettings, "warning_text");
    var iatAttrText = "I-Agree-To-Terms";
    var iatTimeAttrText = "Accepted-Terms-At";
    if(iatCollection.enable_dynamic_attribute == 1){
      iatAttrText = iatloadLanguage(iatAppSettings,"terms_checked_label");
      iatTimeAttrText = iatloadLanguage(iatAppSettings,"terms_time_label");
      
    }

    tingleModal.setContent('<h1 style="text-align: center">' + iatPopupWarning + '</h1>' + iatGetAppHTML);

    tingleModal.open();

    if ($iatjobject.isFunction(window.iatAfterModalLoadHook)) {

        iatAfterModalLoadHook();

    }

    $iatjobject('.text-wrapper input').change(function () {

        if ($iatjobject(this).is(":checked")) {

            var formLength = $iatelement.closest('form').length;

            if (formLength) {

                var iatProperties = '<span class="td-terms-buy-now"><input type="hidden" name="properties['+iatAttrText+']" value="Yes"><input type="hidden" name="properties['+iatTimeAttrText+']" value="' + new Date() + '"></span>';

                if ($iatjobject.isFunction(window.iatModifyProperties)) {

                    if (iatModifyProperties(iatProperties)) {

                        iatProperties = iatModifyProperties(iatProperties);

                    }

                }

                $iatelement.closest('form').prepend(iatProperties);

            }

            $iatelement.find('.shopify-payment-button').css({ 'pointer-events': 'auto' });

            $iatelement.removeAttr("onclick");

            setTimeout(function () {

                $iatelement.find('button.shopify-payment-button__button').trigger("click");

            }, 1000);

            tingleModal.close();

        }

    });

}

function iatCheckCountryHandler($iatjobject) {

    return $iatjobject.get("https://wtfismyip.com/json");

}

function iatActions($iatjobject, iatCollection, iatTimeStamp) {

    iatAddCSS();

    if ($iatjobject('.tech-dignity-terms-box').length > 0) {

        var placeElementFlag = 2;

    } else {

        var placeElementFlag = 1;

    }

    

    iatLoadApp($iatjobject, iatCollection, iatTimeStamp, placeElementFlag);



    if (iatCollection.required == 1) {

        $iatjobject('.additional-checkout-buttons').css({ 'opacity': 0.5, 'pointer-events': 'none' });

        // For Login Page

        if ((iatloginForm.length >= 1 && iatCollection.login_page) || (iatRegistrationForm.length >= 1 && iatCollection.register_page) || (iatContactForm.length >= 1 && iatCollection.contact_page)) {

            // To solve Login checked attribute issue in alert message

            // $iatjobject('.text-wrapper input[type="checkbox"]').change(function () {

            //     if ($iatjobject('.agree-to-terms-wrapper .text-wrapper input[type="checkbox"]').is(':checked')) {

            //         $iatjobject('.text-wrapper input[type="checkbox"]').removeAttr('checked');

            //     } else {

            //         $iatjobject('.text-wrapper input[type="checkbox"]').attr('checked', 'checked');

            //     }

            // });

            var iatElimentcheck = iatButtonSelector(iatCollection);

            if (iatCollection.td_style == 1) {

                iatTdStyleOne(iatElimentcheck, iatCollection);

            } else {

                iatTdStyleTwo(iatElimentcheck, iatCollection);

            }

        }



        $iatjobject('.agree-to-terms-wrapper input').change(function () {

            if ($iatjobject(this).is(":checked")) {

                $iatjobject('.additional-checkout-buttons').css({ 'opacity': 1, 'pointer-events': 'auto' });

            } else {

                $iatjobject('.additional-checkout-buttons').css({ 'opacity': 0.5, 'pointer-events': 'none' });

            }

        });

    }



    var tdLoadCart = 0;

    if (iatCollection.enable_specific_product == 1) {
        
        $iatjobject.getJSON('/cart.js', function (cart) {

            

            if (cart != '') {

                var tdCartItems = cart.items;
                
                $iatjobject.each(tdCartItems, function (key, tdItem) {
                      
                    var tdProductData = igtGetProduct(tdItem.handle);
                    
                    var tdProductFlag = igtProductCheck(tdProductData, iatCollection);
                    //console.log(tdProductFlag);
                    if (tdProductFlag == true) {

                        tdLoadCart = 1;

                    }

                });

            }

            if (tdLoadCart == 1) {

                if (iatCollection.required == 1) {

                    var iatElimentcheck = '[name="checkout"], [name="goto_pp"], [name="goto_gc"], .igtChekout';

                    if (iatCollection.td_style == 1) {

                        iatTdStyleOne(iatElimentcheck, iatCollection);

                    } else {

                        iatTdStyleTwo(iatElimentcheck, iatCollection);

                    }

                }

            }

        });

    } else {

        // Set Validation if required

        if (iatCollection.required == 1) {

            var iatElimentcheck = '[name="checkout"], [name="goto_pp"], [name="goto_gc"], .igtChekout';

            if (iatCollection.td_style == 1) {

                iatTdStyleOne(iatElimentcheck, iatCollection);

            } else {

                iatTdStyleTwo(iatElimentcheck, iatCollection);

            }

        }

    }

}



function iatTdStyleOne(iatElimentcheck, iatCollection) {

    $iatjobject('body').on('click', iatElimentcheck, function (e) {

        if ($iatjobject('.agree-to-terms-wrapper .text-wrapper input').is(':checked')) { // #td-terms-' + iatTimeStamp

            var iatResponse = {};

            if ($iatjobject.isFunction(window.iatAfterClickCheckoutBtn)) {

                iatResponse = iatAfterClickCheckoutBtn(iatResponse);

            }

            if (!$iatjobject.isEmptyObject(iatResponse)) {

                if (!iatResponse.success) {

                    return false;

                }

            }

            $iatjobject(this).submit();

            return true;

        } else {

            var warningText = iatGetWarningMessage(iatCollection);

            if ($iatjobject.isFunction(window.iatModifyErrorMessage)) {

                if (iatModifyErrorMessage(warningText)) {

                    warningText = iatModifyErrorMessage(warningText);

                }

            }

            alert(warningText);

            e.preventDefault();

            e.stopPropagation();

            e.stopImmediatePropagation();

            return false;

        }

    });

}



function iatTdStyleTwo(iatElimentcheck, iatCollection) {

    var iatDefaultChecked = parseInt(iatCollection.default_checked);

    if (!iatDefaultChecked) {

        iatEnableButtons(iatCollection);

    }

    $iatjobject('.text-wrapper input').change(function () {

        if ($iatjobject(this).is(":checked")) {

            var iatResponse = {};

            if ($iatjobject.isFunction(window.iatAfterClickCheckoutBtn)) {

                iatResponse = iatAfterClickCheckoutBtn(iatResponse);

            }

            //console.log(iatResponse);

            if (!$iatjobject.isEmptyObject(iatResponse)) {

                if (!iatResponse.success) {

                    $iatjobject('.td-warning').show();

                    iatEnableButtons(iatCollection);

                } else {

                    $iatjobject('.td-warning').hide();

                    iatDisableButtons(iatCollection);

                }

            } else {

                $iatjobject('.td-warning').hide();

                iatDisableButtons(iatCollection);

            }

        } else {

            $iatjobject('.td-warning').show();

            iatEnableButtons(iatCollection);

        }

    });

}



function iatButtonSelector(settings) {

    // var iatElimentcheck = '[name="checkout"], [name="goto_pp"], [name="goto_gc"], .igtChekout';

    var iatElimentcheck = "";

    // For Login Page

    if (iatloginForm.length >= 1 && settings.login_page) {

        iatElimentcheck = 'form[action="/account/login"] button, form[action="/account/login"] input[type=submit], .igtLogin';

    }

    // For Registration Page

    if (iatRegistrationForm.length >= 1 && settings.register_page) {

        iatElimentcheck = 'form[action="/account"] button, form[action="/account"] input[type=submit], .igtRegistration';

    }

    // For Contact Page
    if(iatContactForm.length >= 1 && settings.contact_page) {
      iatElimentcheck = 'form[action="/contact#ContactForm"] button, form[action="/contact#ContactForm"] input[type=submit], .igtContact';    
    }

    return iatElimentcheck;

}

function iatEnableButtons(settings) {

    // checkout button

    $iatjobject('[name="checkout"], [name="goto_pp"], [name="goto_gc"], .igtChekout').prop("disabled", true);

    // login  

    if (iatloginForm.length >= 1 && settings.login_page) {

        iatloginForm.prop("disabled", true);

    }

    // registration

    if (iatRegistrationForm.length >= 1 && settings.register_page) {

        iatRegistrationForm.prop("disabled", true);

    }

    // Contact  
    if(iatContactForm.length >= 1 && settings.contact_page){    

      iatContactForm.prop("disabled", true);

    }

}

function iatDisableButtons(settings) {

    // checkout button

    $iatjobject('[name="checkout"], [name="goto_pp"], [name="goto_gc"], .igtChekout').prop("disabled", false);

    // login

    if (iatloginForm.length >= 1 && settings.login_page) {

        iatloginForm.prop("disabled", false);

    }

    // registration

    if (iatRegistrationForm.length >= 1 && settings.register_page) {

        iatRegistrationForm.prop("disabled", false);

    }

    // Contact
   if(iatContactForm.length >= 1 && settings.contact_page){
      iatContactForm.prop("disabled", false);
    }

}

function iatGetWarningMessage(settings) {

    var iatwarningText = iatloadLanguage(settings, "warning_text");

    // var warningText = settings.warning_text;

    // For Login Page error message

    if (iatloginForm.length >= 1 && settings.login_page) {

        iatwarningText = iatloadLanguage(settings, "login_error_msg");

    }

    // For Registration Page error message

    if (iatRegistrationForm.length >= 1 && settings.register_page) {

        iatwarningText = iatloadLanguage(settings, "register_error_msg");

    }

    // For Contact Page error message
    if(iatContactForm.length >= 1 && settings.contact_page){
      iatwarningText = iatloadLanguage(settings,"contact_error_msg");
    }

    return iatwarningText;

}

function iatGetWarningMessageHTML(iatStyleWarning, settings) {

    var iatwarningText = iatloadLanguage(settings, "warning_text");

    var iatWarningTextHtml = '<span class="td-warning" ' + iatStyleWarning + '>' + iatwarningText + '</span>';

    // For Login Page error message

    if (iatloginForm.length >= 1 && settings.login_page) {

        var iatwarningText = iatloadLanguage(settings, "login_error_msg");

        iatWarningTextHtml = '<span class="td-warning" ' + iatStyleWarning + '>' + iatwarningText + '</span>';

    }

    // For Registration Page error message

    if (iatRegistrationForm.length >= 1 && settings.register_page) {

        var iatwarningText = iatloadLanguage(settings, "register_error_msg");

        iatWarningTextHtml = '<span class="td-warning" ' + iatStyleWarning + '>' + iatwarningText + '</span>';

    }

    // For Contact Page error message
    if(iatContactForm.length >= 1 && settings.contact_page){
      var iatwarningText = iatloadLanguage(settings,"contact_error_msg");
      iatWarningTextHtml = '<span class="td-warning" '+iatStyleWarning+'>'+iatwarningText+'</span>';    
    }

    return iatWarningTextHtml;

}

function igtGetProduct(handle) {

    $iatjobject.ajax({

        dataType: 'json',

        cache: false,

        async: false,

        url: '/products/' + handle + '.json',

        success: function (data) {

            pioProductData = data.product;

        },

        error: function (error) {

            throw 'Pio product lookup error';

        },

    });

    return pioProductData;

}

function igtProductCheck(igtProductData, iatCollection) {
    
    var productConditionArray = $iatjobject.map(

        iatCollection.specific_product.customize.split(','),

        $iatjobject.trim

    );
  
    switch (iatCollection.specific_product.product_tag) {

        case 1:

            // Type

            var productType = igtProductData.product_type;

            if (igtProductData != '' && $iatjobject.inArray(productType, productConditionArray) != -1) {

                return true;

            } else {

                return false;

            }

            break;

        case 2:

            // Handle

            var tdProductHandle = igtProductData.handle;

            if (igtProductData != '' && $iatjobject.inArray(tdProductHandle, productConditionArray) != -1) {

                return true;

            } else {

                return false;

            }

            break;

        case 3:

            // Vendor

            var tdVendor = igtProductData.vendor;

            if (igtProductData != '' && $iatjobject.inArray(tdVendor, productConditionArray) != -1) {

                return true;

            } else {

                return false;

            }

            break;
       case 4:

            // Tags

            var productTags = $iatjobject.map(
                igtProductData.tags.split(','),
                $iatjobject.trim
            );
            
            if (igtProductData != '') {
                var igtFlag = 0;
              //console.log(productConditionArray);
              //productConditionArray = ['men'];
              productConditionArray = JSON.parse(productConditionArray);
                $.each(productTags, function( key, value ) {
                    var index = $.inArray( value, productConditionArray );
                    if( index != -1 ) {
                        igtFlag = 1;
                    }
                });
                if (igtFlag == 1) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }

            break;
    }

}

function iatSetupCheckbox(iatSelector, iatHtml) {

    iatSelector.before(iatHtml);

    if ($iatjobject.isFunction(window.iatAfterLoadHook)) {

        iatAfterLoadHook();

    }

    //Auto add properties when checkbox is checked start
    if(iatloginForm.length <= 0 && iatRegistrationForm.length <= 0 && iatContactForm.length <= 0){ 
        $iatjobject('.text-wrapper').on('change', 'input', function(){
            if ($iatjobject(this).is(':checked')) {
                
                var iatAttrName = "I-Agree-To-Terms";
                var iatTimeAttrName = "Accepted-Terms-At";
        
                if(iatAppSettings.enable_dynamic_attribute == 1){
                  iatAttrName = iatloadLanguage(iatAppSettings,"terms_checked_label");
                  iatTimeAttrName = iatloadLanguage(iatAppSettings,"terms_time_label");
                }
                var datetime = new Date();
                var tdAttr ={};
                tdAttr[iatAttrName] = 'Yes';
                tdAttr[iatTimeAttrName] = datetime;
                var td_params = {
                  type: 'POST',
                  url: '/cart/update.js',
                  data: { attributes: tdAttr },
                  dataType: 'json',
                  cache : false,
                  async: false
                };
                $iatjobject.ajax(td_params).always(function() {      
                  console.log("Terms and conditions accepted");
                });
            }
          }); 
    }
    //Auto add properties when checkbox is checked end

}

